import { useEffect, useState } from "react";
import {
  getAuthToken,
  requestClientProfileFromParent,
  subscribeToBrandigiopsAuth,
  subscribeToBrandigiopsClientProfile,
} from "../utils/brandigiopsAuth";

export const useBrandigiopsAuth = () => {
  const [token, setToken] = useState(() => getAuthToken());

  useEffect(() => {
    const existing = getAuthToken();
    if (existing) setToken(existing);

    return subscribeToBrandigiopsAuth((receivedToken) => {
      setToken(receivedToken);
    });
  }, []);

  return token;
};

export const useBrandigiopsClientProfile = (clientId) => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (!clientId) return;

    requestClientProfileFromParent(clientId);

    return subscribeToBrandigiopsClientProfile((receivedProfile) => {
      setProfile(receivedProfile);
    });
  }, [clientId]);

  return profile;
};
